export enum AvatarState {
  SingleActiveUser,
  SingleInactiveUser,
  MultipleUsers
}
